import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from 'antd';

import { Default } from '../../../../layouts';

import useDatasource from '../../../../hooks/useDatasource';
import { findAll, remove } from '../../../../services/admin/sectors';

import PageTitle from '../../../../components/PageTitle';
import AddEntityButton from '../../../../components/buttons/AddEntityButton';
import EditItemIcon from '../../../../components/buttons/EditItemIcon';

import Column from '../../../../helpers/columns';
import DeleteItemIcon from '../../../../components/buttons/DeleteItemIcon';
import usePermissions from '../../../../hooks/usePermission';
import ViewItemIcon from '../../../../components/buttons/ViewItemIcon';

const permissionsMap = {
  canView: ['ADMINISTRATION_TAXONOMIES_VIEW_PERMISSION'],
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
  canDelete: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const SectorSectorsList = () => {
  const { t } = useTranslation();
  const { canView, canEdit, canDelete } = usePermissions(permissionsMap);
  const { pagination, content, handleChange, reload } = useDatasource(findAll);

  const columns = useMemo(
    () => [
      Column.text('name', t('entity.taxonomy.sector.name'), {
        filter: true,
      }),
      Column.text('description', t('entity.taxonomy.sector.description'), {
        filter: true,
      }),
      Column.bool('deleted', t('entity.taxonomy.sector.deleted._'), {
        width: 100,
        filter: true,
        inverted: true,
        labels: [
          t('table.filter.all'),
          t('entity.taxonomy.sector.deleted.true'),
          t('entity.taxonomy.sector.deleted.false'),
          t('table.filter.unknown'),
        ],
      }),
      Column.actions(t('table.actions'), (record) => (
        <>
          {canView && (
            <ViewItemIcon path={`/admin/taxonomies/sectors/${record.id}`} />
          )}
          {canEdit && (
            <EditItemIcon path={`/admin/taxonomies/sectors/${record.id}`} />
          )}
          {canDelete && (
            <DeleteItemIcon
              title={t('entity.taxonomy.sector.delete._', record)}
              message={t('entity.taxonomy.sector.delete.deleted', record)}
              item={record}
              disabled={record.deleted}
              action={remove}
              reload={reload}
            />
          )}
        </>
      )),
    ],
    [canDelete, canEdit, canView, reload, t],
  );

  return (
    <Default>
      <PageTitle title={t('entity.taxonomy.sector._plural')}>
        {canEdit && (
          <AddEntityButton
            entity={t('entity.taxonomy.sector._singular')}
            path="/admin/taxonomies/sectors/new"
          />
        )}
      </PageTitle>
      <Table
        columns={columns}
        rowKey="id"
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
        scroll={{ x: 700, y: 700 }}
      />
    </Default>
  );
};

export default SectorSectorsList;
